<template>
  <div class="activity-container">
    <van-nav-bar :title="t('mensagens.title')" left-text="" left-arrow :border="false" class="custom-nav-bar">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="activity-header px-[10px]">
      <div class="tabs p-[2px]">
        <div v-for="(tab, idx) in tabs" v-trans="{
          type: 'heartbeat',
          scale: 1.05,
          duration: 100,
        }" :key="tab.value" @click="handleTabClick(idx)" :class="['tab-item', { active: idx === activeTab }]"
          v-show="!showOnlySupport || idx === 0" class="relative">
          <div class="tab-content">
            {{ tab.label }}

          </div>
          <!-- 站内信红点 - 只有在登录状态下才显示 -->
          <!-- <div v-if="idx === 1 && isLoggedIn && messageStore.count > 0" class="tab-badge-dot">
            {{ messageStore.count > 99 ? "99+" : messageStore.count }}
          </div> -->
          <RedDot v-if="idx === 1 && isLoggedIn && messageStore.count > 0" class="absolute top-[2px] right-[2px]"
            :count="messageStore.count" :big="messageStore.count > 10" />

          <!-- <div v-if="idx === activeTab" class="tab-underline"></div> -->
        </div>
      </div>
    </div>

    <div class="support-list h-[calc(100vh-100px)]" v-if="activeTab === 0">
      <div class="support-card main relative">
        <div class="absolute left-0 -top-[11%]">
          <img :src="getAssetsFile('message/mainBg.png')" alt="" class="w-full h-auto">
        </div>
        <div class="w-2.7/10 flex h-full relative">
          <!-- <img :src="getAssetsFile('home/touxs.png')" alt="" class="w-[56px] h-[56px]" /> -->
          <!-- <div class="w-[20px] h-full absolute right-0 top-0"></div> -->
        </div>

        <div class="main-info py-[12px] pr-[10px] w-7.3/10 relative z-10">
          <!-- <div class="main-title">{{ t('mensagens.onlineSupport24') }}</div> -->
          <div class="main-desc">

            {{ t('mensagens.onlineSupportDesc') }}
          </div>
          <div class="w-full flex justify-end">
            <Button type="small" class="main-btn !w-[77px] !h-[25px]" @click="gosoon(1)">{{ t("mensagens.contact")
              }}</Button>
          </div>
        </div>
      </div>
      <div class="support-card relative" v-for="(item, index) in siteDisplayConfig" :key="index">
        <div class="absolute left-0 top-0 w-full h-full">
          <img :src="getAssetsFile('message/messageBg.png')" alt="" class="w-full h-full">
        </div>
        <div class="w-2.6/10 relative z-10">
          <div class="w-[calc(100%-20px)] h-full flex items-center justify-center">
            <img :src="VITE_IMG_URL + item.icon" alt="" class="w-[40px] h-[40px] rounded-[50%]" />
          </div>

          <div class="w-[20px] h-full absolute right-0 top-0"></div>
        </div>

        <div class="py-[12px] pr-[10px] w-7.4/10 relative z-10">
          <div class="support-info">
            <div class="support-title">{{ item.type }}</div>
            <div class="support-desc flex w-full">
              <div class="w-full two-line-ellipsis">
                {{ item.remark }}
              </div>
              <div class="flex justify-end">
                <Button type="small" class="support-btn !w-[77px] !h-[25px]" @click="gowaseek(item.url)">{{
                  t("mensagens.contact") }}</Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- 通知列表 - 只有在登录状态下才显示 -->
    <div class="notification-list" v-if="activeTab === 1 && isLoggedIn" @scroll="handleScroll" ref="containerRef">
      <div class="flex items-center justify-between">
        <div></div>
        <div v-if="messageStore.count" class="bgs"
          :style="{ backgroundImage: `url(${getAssetsFile('activity/bgyuanxin.png')})` }" @click="readAllMessages">
          <img :src="getAssetsFile('activity/bgyuanxing (2).png')" alt="" class="w-[18px] h-[18px]" />
          <div class="text-[11px] text-[#fff] ml-[10px]">
            {{ t("mensagens.readAll") }}
          </div>
        </div>
      </div>

      <!-- 通知项列表 -->
      <div v-for="(item, idx) in notifications" :key="item.id || idx" class="notification-item relative"
        @click="goToDetail(item)">

        <div class="notification-time">{{ formatTime(item.createTime) }}</div>
        <div class="notification-box flex relative h-[64px]">
          <div class="absolute left-0 top-0 w-full h-full">
            <img :src="getAssetsFile('message/messageBg.png')" alt="" class="w-full h-full">
          </div>
          <div class="w-2.7/10 h-full relative z-10">
            <div class="w-[calc(100%-20px)] h-full flex items-center justify-center">
              <img :src="getAssetsFile('message/mail.png')" alt="" class="w-[46px] h-[37px]" />
            </div>
          </div>
          <div class="w-7.3/10 h-full relative z-10 py-[8px] px-[7px]">
            <div class="notification-title whitespace-nowrap text-ellipsis overflow-hidden"
              v-html="parseTitle(item.title)">
            </div>
            <div class="notification-content two-line-ellipsis !lh-[12px]" v-html="parseContent(item.msg)"></div>
          </div>

          <!-- 添加未读小红点 -->
          <div v-if="!item.read" class="unread-dot"></div>
        </div>
      </div>

      <!-- 加载更多提示 -->
      <div v-if="loading" class="loading-more">
        <div class="loading-spinner"></div>
        <span>{{ t("mensagens.loading") }}</span>
      </div>

      <!-- 没有更多数据提示 -->
      <div v-if="finished && notifications.length > 0" class="no-more">
        {{ t("mensagens.noMoreData") }}
      </div>
    </div>
  
    <div class="announcement-list" v-if="activeTab === 2">
      <div class="empty-data">
        <div class="flex justify-center items-center">
          <img :src="getAssetsFile('home/No_record@2x.png')" alt="" class="max-h-[84px] max-w-[106.5px] w-auto h-auto">
        </div>
        <div class="empty-text">{{ t("mensagens.noRecords") }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RedDot } from "@/components/RedDot";
import { Button } from "@/components/Button";
import { ref, onMounted, watch, onBeforeUnmount, nextTick, computed } from "vue";
import * as GameApi from "@/api/game";
import dayjs from "dayjs";
const VITE_IMG_URL = import.meta.env.VITE_IMG_URL;
import useUIStore from "@/stores/modules/ui";
import { useMessageStore } from "@/stores/modules/message";
import { useUserStore } from "@/stores/modules/user"; // 添加用户store导入
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { getAssetsFile } from "@/utils/pub-use";
import {
  trackMessageCenterClickNotificationButton,
  trackMessageCenterClickAnnouncementButton,
  trackMessageCenterClickOnlineSupportButton,
  trackMessageCenterClickFacebookButton,
  trackMessageCenterClickTelegramButton,
  trackMessageCenterClickWhatsappButton,
} from "@/utils/firebase-analytics";
import { formatTime } from "@/utils/date";

const uiStore = useUIStore();
const messageStore = useMessageStore();
const userStore = useUserStore(); // 添加用户store
const router = useRouter();
const route = useRoute();
const { t } = useI18n();

// 获取登录状态
const isLoggedIn = computed(() => userStore.isLoggedIn);

// 先定义 activeTab，然后再定义其他依赖它的变量
const activeTab = ref(0);

// 根据登录状态动态生成tabs
const tabs = computed(() => {
  const baseTabs = [{ label: t("mensagens.support"), value: "Suporte" }];

  // 只有在登录状态下才显示Notificação标签
  if (isLoggedIn.value) {
    baseTabs.push({ label: t("mensagens.notification"), value: "Notificação" });
  }

  return baseTabs;
});

// 监听路由参数变化
watch(
  () => route.query.activeTab,
  (newTab) => {
    if (newTab === "1") {
      activeTab.value = 1;
    }
  },
  { immediate: true }
);

// 分页参数
const params = ref({
  pageNo: 1,
  pageSize: 10,
  msgType: "",
});
const notifications = ref([]);
const loading = ref(false);
const finished = ref(false);
const containerRef = ref(null);

// 添加解析函数
const parseTitle = (title: string) => {
  try {
    const titleObj = JSON.parse(title);
    let content = titleObj.en || titleObj.pt || titleObj.zh || "";

    // 清理HTML中的内联样式
    content = content.replace(/style="[^"]*"/g, ""); // 移除所有style属性
    content = content.replace(/width="[^"]*"/g, ""); // 移除width属性
    content = content.replace(/height="[^"]*"/g, ""); // 移除height属性

    return content;
  } catch (e) {
    return title;
  }
};

const parseContent = (msg: string) => {
  try {
    const msgObj = JSON.parse(msg);
    let content = msgObj.en || msgObj.pt || msgObj.zh || "";

    // 清理HTML中的内联样式
    content = content.replace(/style="[^"]*"/g, ""); // 移除所有style属性
    content = content.replace(/width="[^"]*"/g, ""); // 移除width属性
    content = content.replace(/height="[^"]*"/g, ""); // 移除height属性

    return content;
  } catch (e) {
    return msg;
  }
};

// 加载数据函数
const loadData = async () => {
  try {
    loading.value = true;

    const res = await GameApi.siteMsglist(params.value);
    const newList = res.data.list || [];

    notifications.value = newList;
    finished.value = newList.length < params.value.pageSize;

    return res;
  } catch (error) {
    console.error("加载消息列表失败:", error);
    throw error;
  } finally {
    loading.value = false;
  }
};

// 重置分页状态
const resetPagination = () => {
  params.value.pageNo = 1;
  finished.value = false;
  loading.value = false;
  notifications.value = [];
};

// 加载更多数据
const loadMore = async () => {
  if (loading.value || finished.value) return;

  loading.value = true;
  try {
    params.value.pageNo += 1;

    const res = await GameApi.siteMsglist(params.value);
    const newList = res.data.list || [];

    if (newList.length > 0) {
      notifications.value = [...notifications.value, ...newList];
    }

    // 判断是否还有更多数据
    finished.value = newList.length < params.value.pageSize;
  } catch (error) {
    // 加载失败时，页码回退
    params.value.pageNo -= 1;
    console.error("加载更多失败:", error);
  } finally {
    loading.value = false;
  }
};

// 滚动加载处理
const handleScroll = (e) => {
  if (loading.value || finished.value) {
    return;
  }

  const { scrollTop, scrollHeight, clientHeight } = e.target;

  // 当滚动到距离底部50px时触发加载
  if (scrollHeight - scrollTop - clientHeight < 50) {
    loadMore();
  }
};

// 手动触发滚动监听（备用方案）
const checkScroll = () => {
  if (!containerRef.value) return;

  const element = containerRef.value;
  const { scrollTop, scrollHeight, clientHeight } = element;

  if (scrollHeight - scrollTop - clientHeight < 50 && !loading.value && !finished.value) {
    loadMore();
  }
};

const onClickLeft = () => {
  if (sessionStorage.getItem("fromSidebar") === "true") {
    uiStore.openSidebar();
    sessionStorage.removeItem("fromSidebar");
  }
  history.back();
};

const goToDetail = async (item: any) => {
  try {
    await GameApi.siteMsglistread({
      userId: 0,
      msgIds: [item.id],
    });

    item.read = true;

    const currentCount = messageStore.count;
    if (currentCount > 0) {
      messageStore.setCount(currentCount - 1);
    }

    router.push({
      path: "/mensagens/Detalhes",
      query: {
        message: encodeURIComponent(JSON.stringify(item)),
      },
    });
  } catch (error) {
    console.error("标记消息已读失败:", error);
    router.push({
      path: "/mensagens/Detalhes",
      query: {
        message: encodeURIComponent(JSON.stringify(item)),
      },
    });
  }
};

const readAllMessages = async () => {
  try {
    await GameApi.readAll();
    messageStore.setCount(0);
    resetPagination();
    await loadData();
  } catch (error) {
    console.error("一键已读失败:", error);
  }
};

// 监听tab切换 - 移到最后，确保所有函数都已定义
watch(activeTab, (newTab) => {
  // 只有在登录状态下才能切换到通知标签
  if (newTab === 1 && isLoggedIn.value) {
    resetPagination();
    loadData();
  }
});

// 添加跳转到mensagens页面的函数
const goToMensagens = () => {
  // 设置标记，表示是从侧边栏跳转的
  sessionStorage.setItem("fromSidebar", "true");
  router.push("/mensagens");
};

// 添加新的客服图标点击函数
const goToMensagensFromKefus = () => {
  // 移除对 isLogin 的引用，或者添加相应的导入
  // if (!isLogin.value) {
  //   // 未登录情况下，设置标记只显示Support标签页
  //   sessionStorage.setItem('showOnlySupport', 'true')
  // }
  router.push("/mensagens");
};

const showOnlySupport = ref(false);
const siteDisplayConfig = ref([]);
onMounted(async () => {
  // 检查是否只显示Support标签页
  if (sessionStorage.getItem("showOnlySupport") === "true") {
    showOnlySupport.value = true;
    activeTab.value = 0; // 强制设置为Support标签页
    sessionStorage.removeItem("showOnlySupport"); // 清除标记
  }

  // 检查是否从详情页返回
  if (sessionStorage.getItem("returnFromDetail") === "true") {
    activeTab.value = 1;
    sessionStorage.removeItem("returnFromDetail");
  }

  // 检查是否有指定的标签页索引
  const activeTabIndex = sessionStorage.getItem("activeTabIndex");
  if (activeTabIndex !== null) {
    activeTab.value = parseInt(activeTabIndex);
    sessionStorage.removeItem("activeTabIndex"); // 清除标记
  }

  if (activeTab.value === 1) {
    loadData();
  }

  // 添加定时检查滚动（备用方案）
  const scrollInterval = setInterval(() => {
    if (activeTab.value === 1) {
      checkScroll();
    }
  }, 1000);

  const socket = window.$socket;
  if (socket) {
    socket.on("red_point_notice", (data) => {
      const count = data?.redPointMap?.[1] || 0;
      messageStore.setCount(count);
    });
  }

  // 清理定时器
  onBeforeUnmount(() => {
    clearInterval(scrollInterval);
    if (window.$socket && window.$socket.off) {
      window.$socket.off("red_point_notice");
    }
  });
  const res = await GameApi.getSiteDisplayConfig();
  siteDisplayConfig.value = res.data;
});
// LiveChat 加载状态
let liveChatLoading = false
let liveChatLoaded = false

// 动态加载 LiveChat 脚本（使用标准 LiveChat 代码）
const loadLiveChatScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    // 如果已经加载完成，直接返回
    if (liveChatLoaded && (window as any).LiveChatWidget) {
      resolve()
      return
    }

    // 如果正在加载，等待加载完成
    if (liveChatLoading) {
      const checkInterval = setInterval(() => {
        if (liveChatLoaded && (window as any).LiveChatWidget) {
          clearInterval(checkInterval)
          resolve()
        }
      }, 100)

      // 15秒超时
      setTimeout(() => {
        clearInterval(checkInterval)
        if (!liveChatLoaded) {
          reject(new Error('LiveChat 加载超时'))
        }
      }, 15000)
      return
    }

    // 检查脚本是否已经存在
    const existingScript = document.querySelector('script[src*="cdn.livechatinc.com/tracking.js"]')
    if (existingScript && (window as any).LiveChatWidget) {
      // 脚本已存在，使用事件监听等待就绪
      liveChatLoading = true

      // 尝试使用 once 事件
      if (typeof (window as any).LiveChatWidget.once === 'function') {
        ; (window as any).LiveChatWidget.once('ready', () => {
          liveChatLoading = false
          liveChatLoaded = true
          resolve()
        })
      } else {
        // 回退到轮询
        const checkInterval = setInterval(() => {
          if ((window as any).LiveChatWidget && (window as any).LiveChatWidget._h) {
            clearInterval(checkInterval)
            liveChatLoading = false
            liveChatLoaded = true
            resolve()
          }
        }, 100)

        setTimeout(() => {
          clearInterval(checkInterval)
          liveChatLoading = false
          if (!liveChatLoaded) {
            reject(new Error('LiveChat 加载超时'))
          }
        }, 15000)
      }
      return
    }

    // 开始加载
    liveChatLoading = true

    // 使用标准 LiveChat 代码初始化
    if (!(window as any).LiveChatWidget) {
      // 设置 LiveChat 配置
      ; (window as any).__lc = (window as any).__lc || {}
      ; (window as any).__lc.license = 19175176
      ; (window as any).__lc.integration_name = "manual_channels"
      ; (window as any).__lc.product_name = "livechat"

      // 标准 LiveChat 初始化代码
      ; (function (n, t, c) {
        function i(n) {
          return e._h ? e._h.apply(null, n) : e._q.push(n)
        }
        var e = {
          _q: [],
          _h: null,
          _v: "2.0",
          on: function () {
            i(["on", c.call(arguments)])
          },
          once: function () {
            i(["once", c.call(arguments)])
          },
          off: function () {
            i(["off", c.call(arguments)])
          },
          get: function () {
            if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.")
            return i(["get", c.call(arguments)])
          },
          call: function () {
            i(["call", c.call(arguments)])
          },
          init: function () {
            var n = t.createElement("script")
            n.async = !0
            n.type = "text/javascript"
            n.src = "https://cdn.livechatinc.com/tracking.js"
            t.head.appendChild(n)
          }
        }
        if (!(n as any).__lc.asyncInit) {
          e.init()
        }
        ; (n as any).LiveChatWidget = (n as any).LiveChatWidget || e
      })(window, document, [].slice)
    }

    // 使用事件监听等待就绪
    let timeoutId: number | null = null
    let resolved = false

    const markResolved = () => {
      if (!resolved) {
        resolved = true
        if (timeoutId) {
          clearTimeout(timeoutId)
          timeoutId = null
        }
        liveChatLoading = false
        liveChatLoaded = true
        resolve()
      }
    }

    // 先检查是否已经就绪
    if ((window as any).LiveChatWidget && (window as any).LiveChatWidget._h) {
      markResolved()
      return
    }

    // 设置超时
    timeoutId = window.setTimeout(() => {
      if (!resolved) {
        liveChatLoading = false
        // 即使超时，如果 LiveChatWidget 存在，也认为可以尝试使用
        if ((window as any).LiveChatWidget) {
          console.warn('LiveChat 加载超时，但将尝试使用')
          markResolved()
        } else {
          reject(new Error('LiveChat 加载超时'))
        }
      }
    }, 15000)

    // 使用事件监听
    if ((window as any).LiveChatWidget && typeof (window as any).LiveChatWidget.once === 'function') {
      ; (window as any).LiveChatWidget.once('ready', () => {
        console.log('LiveChat 已就绪（通过事件）')
        markResolved()
      })
    }

    // 同时使用轮询作为备用
    const checkInterval = setInterval(() => {
      if (resolved) {
        clearInterval(checkInterval)
        return
      }

      if ((window as any).LiveChatWidget && (window as any).LiveChatWidget._h) {
        console.log('LiveChat 已就绪（通过轮询）')
        markResolved()
        clearInterval(checkInterval)
      }
    }, 200)
  })
}

const gosoon = (type: number) => {
  if (type === 1) {
    const openLiveChat = async () => {
      try {
        // 如果已经加载完成，直接尝试打开
        if (liveChatLoaded && (window as any).LiveChatWidget) {
          try {
            // 即使 _h 不存在，也尝试调用（LiveChatWidget 会将调用放入队列）
            ; (window as any).LiveChatWidget.call('maximize')
            console.log('客服窗口已打开（已加载）')
            return true
          } catch (e) {
            console.warn('直接调用失败，尝试重新加载:', e)
            liveChatLoaded = false
          }
        }


        // 加载 LiveChat 脚本（即使有 url 错误也继续）
        try {
          await loadLiveChatScript()
        } catch (error) {
          console.warn('加载 LiveChat 脚本超时，但继续尝试使用:', error)
          // 不直接失败，继续尝试
        }

        // 等待一段时间让脚本初始化（即使有 url 错误也可能可用）
        await new Promise(resolve => setTimeout(resolve, 2000))

        // 尝试打开客服窗口（即使 _h 可能不存在，也尝试调用）
        if ((window as any).LiveChatWidget) {
          try {
            ; (window as any).LiveChatWidget.call('maximize')
            console.log('客服窗口已打开')

            // 延迟检查，如果窗口真的没打开，再使用备用方案
            setTimeout(() => {
              // 检查是否有 LiveChat 的窗口元素（使用更宽松的选择器）
              const lcWidget = document.querySelector('#chat-widget-container, [data-lc-widget], iframe[src*="livechat"], .lc-chat-widget')
              if (!lcWidget && (window as any).LiveChatWidget && !(window as any).LiveChatWidget._h) {
                // 只有在确实没有 _h 且没有窗口元素时才使用备用方案
                console.warn('LiveChat 可能未正常工作，使用备用方案')
                const liveChatUrl = 'https://direct.lc.chat/19175176/'
                window.open(liveChatUrl, '_blank')
              }
            }, 3000)

            return true
          } catch (e) {
            console.warn('调用 maximize 失败，使用备用方案:', e)
            // 调用失败，使用备用方案
            const liveChatUrl = 'https://direct.lc.chat/19175176/'
            window.open(liveChatUrl, '_blank')
            return false
          }
        } else {
          console.warn('LiveChatWidget 不存在，使用备用方案')
          // LiveChatWidget 不存在，使用备用方案
          const liveChatUrl = 'https://direct.lc.chat/19175176/'
          window.open(liveChatUrl, '_blank')
          return false
        }
      } catch (error) {
        console.error('打开客服窗口失败:', error)

        // 备用方案：直接打开 LiveChat 链接
        try {
          const liveChatUrl = 'https://direct.lc.chat/19175176/'
          window.open(liveChatUrl, '_blank')
        } catch (e) {
          console.error('打开备用链接失败:', e)
        }
        return false
      }
    }

    openLiveChat()
  }
};
const gowaseek = (url: string) => {
  // 检查URL是否包含协议，如果没有则添加https://
  let fullUrl = url;
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    fullUrl = "https://" + url;
  }
  window.open(fullUrl, "_blank");
};

const handleTabClick = (idx: number) => {
  // 如果点击的是通知标签但用户未登录，则不允许切换
  if (idx === 1 && !isLoggedIn.value) {
    return;
  }

  activeTab.value = idx;
  if (idx === 1) {
    trackMessageCenterClickNotificationButton();
  }
};
</script>

<style lang="scss" scoped>
.two-line-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  word-break: break-all;
  text-align: left;
  line-height: 1.4;
  /* 推荐行高自然值 */
  height: auto !important;
  /* 防止外部高度影响 */
  padding-top: 0 !important;
  /* 防止外部padding影响 */
}

.activity-container {
  min-height: 100vh;
  background: #083a36 !important;
  display: flex;
  flex-direction: column;
}

.custom-nav-bar {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3),
    0px -2px 22px 0px rgba(53, 189, 128, 0.61);
  z-index: 1000;
  height: 56px;

  &>* {
    height: 100%;
  }
}

.activity-header {
  background: #083a36 !important;
  padding: 0 10px;
  height: 47px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  z-index: 1000;
  position: sticky;
  top: 56px;
  left: 0;
  right: 0;
}

.activity-header.sticky {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.tabs {
  display: flex;
  width: 100%;
  background: #001c18;
  border-bottom: 1px solid #015d40;
  white-space: nowrap;
  scrollbar-width: none;
  height: 35px;
  align-items: center;
  border-radius: 100vh;
}

.tabs::-webkit-scrollbar {
  display: none;
}

.tab-item {
  position: relative;
  padding: 12px 12px;
  color: #4cae83;
  cursor: pointer;
  font-weight: 700;
  font-size: 12px;
  transition: color 0.2s, background 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
  border-radius: 4px;
  justify-content: center;
  height: 100%;
  z-index: 10;

  width: 33.33%;
}

.tab-item:last-child {
  margin-right: 0;
}

.tab-item.active {
  background: getPath("home/btn__sel_this.png") no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
  border-radius: 4px;
  font-weight: bold;
  z-index: 1;
}

// .tab-item:active {
//   background: rgba(255, 255, 255, 0.18);
// }

// .tab-item.active:active {
//   background: rgba(255, 255, 255, 0.25);
// }

.tab-underline {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -1px;
  height: 2px;
  width: calc(100%);
  background: #00a97e;
  border-radius: 2px 2px 0 0;
  margin: 0 auto;
}

.support-list {
  padding: 16px 8px 0 8px;
  min-height: 100vh;
}

.support-card {
  background: #104939;
  border-radius: 8px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  position: relative;
  // box-shadow: inset 0px 20px 18px 0px rgba(16, 205, 140, 0.34);
}

.support-card.main {
  flex-direction: row;
  align-items: flex-start;
  // background: getPath("message/mainBg.png") no-repeat;
  // background-size: 100% 100%;
}

.main-info {
  flex: 1;
}

.main-title {
  color: #fff;
  font-size: 15px;
  margin-bottom: 4px;
}

.main-desc {
  color: #4cae83;
  font-size: 9px;
  margin-bottom: 12px;
}

.main-btn {
  background: linear-gradient(180deg, #13c769 0%, #1c9755 100%);
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 15px;
  padding: 7px 22px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(21, 76, 55, 0.12);
  transition: background 0.2s;
}

.support-info {
  margin-left: 10px;
  flex: 1;
}

.support-title {
  color: #fff;
  font-weight: bold;
  font-size: 10px;
}

.support-desc {
  color: #4cae83;
  font-size: 9px;
  margin-top: 10px;

  word-wrap: break-word;
  white-space: normal;
}

.support-btn {
  background: linear-gradient(180deg, #13c769 0%, #1c9755 100%);
  color: #fff;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  font-size: 11px;
  padding: 10px 21px;
  cursor: pointer;
  margin-left: 12px;
  box-shadow: 0 2px 8px rgba(21, 76, 55, 0.12);
  transition: background 0.2s;
}

/* 通知列表样式 */
.notification-list {
  flex: 1;
  padding: 0px 10px 10px 10px;
  overflow-y: auto;
}

.notification-item {
  margin-bottom: 16px;
}

.notification-time {
  color: #4CAE83;
  font-size: 10px;
  text-align: center;
  margin-bottom: 14.5px;
}

.notification-box {
  background: #104939;
  border-radius: 8px;

  color: #fff;
  font-size: 15px;
  display: flex;

  gap: 4px;
  position: relative;
}

.notification-title {
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 6px;
  word-break: break-all;
}

.notification-content {
  color: #42a37a;
  font-size: 10px;
  word-break: break-all;
}

/* 重置富文本中的所有样式 */
.notification-content * {
  max-width: 100% !important;
  box-sizing: border-box !important;
}

.notification-content img {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  display: block !important;
  border-radius: 4px;
  margin: 5px auto !important;
}

.notification-content p {
  margin: 5px 0 !important;
  padding: 0 !important;
}

.notification-content div {
  margin: 0 !important;
  padding: 0 !important;
}

/* 重置标题中的富文本样式 */
.notification-title * {
  max-width: 100% !important;
  box-sizing: border-box !important;
}

.notification-title img {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  display: block !important;
  border-radius: 4px;
  margin: 5px auto !important;
}

.empty-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 115px;
}

.empty-text {
  color: #ADB1B0;
  font-size: 11px;
  margin-top: 21px;
}

.tab-content {
  position: relative;
  display: flex;
  align-items: center;
  z-index: 10;
}

.tab-badge-dot {
  position: absolute;
  top: 0px;
  right: 0px;
  min-width: 13px;
  height: 13px;
  background: #ff3b30;
  border-radius: 50%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 9px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 0 2px;
}

.bgs {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 11px;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  cursor: pointer;
  margin-bottom: 15px;
}

.unread-dot {
  position: absolute;
  top: -8px;
  left: -8px;
  width: 28px;
  height: 25px;
  background: getPath("message/new.png") no-repeat;
  background-size: 100% 100%;

  z-index: 1;
}

/* 加载更多样式 */
.loading-more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #7ec6a7;
  font-size: 14px;
}

.loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #7ec6a7;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.no-more {
  text-align: center;
  padding: 20px;
  color: #7ec6a7;
  font-size: 14px;
}
</style>

<route lang="json5">
{
  name: "mensagens",
  meta: {
    title: "Mensagens",
    i18n: "menus.mensagens",
  },
}
</route>
